<div class="section">
    <div class="px-3">
        <div class="theme-container">
            <h1 class="section-title">Our Digital Signage</h1>
            <p class="section-desc text-muted">This is what we do and we do it perfectly.</p>

            <div fxLayout="row wrap" class="services-wrapper">
                <div fxFlex="100" fxFlex.gt-md="50" fxFlex.gt-sm="50" class="p-2">
                    <mat-card fxLayout="column" fxLayoutAlign="start center" class="h-100 w-100 text-center">
                        <mat-icon class="mat-icon-xlg" color="primary">theaters</mat-icon>
                        <h2 class="secondary-font capitalize fw-600 my-3">Channel 1</h2>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed vestibulum egestas nunc sed ultricies.</p>   

                        <div style="width:100%; background: transparent; height: 100%;">
                            <div style="width:100%; height: 250px; overflow:hidden;
                            background-image:url(assets/images/admir_icon.png); 
                            background-repeat:repeat;">
                                <div class="wrap">
                                    <iframe [src]="iFrameSrcSafeChannel1" frameborder="0"></iframe>
                                </div>
                            </div>
                        </div>

                    </mat-card>
                </div>
                <div fxFlex="100" fxFlex.gt-sm="50" class="py-3">
                    <h1 class="secondary-font primary-color text-center">Digital Signage</h1>
                    <p>We all know digital signage as a digital installation that displays video or multimedia content for informational or advertising purposes. We see it everywhere. We’ve gazed at advertisements at bus stations, found gate information at the airport, ordered food in fast food restaurants, bought movie tickets, pulled up directions at museums, all thanks to digital signage.</p>
                <p>As digital signage increasingly impacts our lives and presents opportunities for the world of business, its capabilities are also evolving from a passive system that pushes content to a more advanced system that connects, interacts, and pulls content from diverse sources in real time.</p>
                </div>
            </div>


            <a mat-raised-button routerLink="/digital-signage" color="primary" class="uppercase">Read more about digital signage.</a>
        </div>
    </div>
</div>